import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aggrement',
  templateUrl: './aggrement.component.html'
})
export class AggrementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

}
